@if (active()) {
  <div class="loader">
    <div class="image slide-in-left">
      <img src="assets/icons/logo.svg">
    </div>
    <!-- <p class="label">Loading ...</p> -->
  </div>
}